import { Route, Routes } from "react-router-dom";
import Header from"./components/Header";
import Login from "./components/Login";
import Register from "./components/Register";
import Home from "./components/HomePage";
import About from "./components/About";
import Footer from "./components/Footer";
import Services from "./components/Services";


function App() {
  return (
    <>
 <div className="min-h-screen flex flex-col">
      <Header/>
      

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
      <Routes>
          <Route path="/header" element={<Header/>}/>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
      


          
      </Routes>
      <Footer/>
      </div>
    </div>    </>
  );
}

export default App;
